export enum RolesEnum {
    Officer = 'Officer',
    DepartmentSupervisor = 'DepartmentSupervisor',
    DepartmentManager = 'DepartmentManager',
    Admin = 'ADMIN',
    L2Support = 'L2Support',
    Technician = 'Technician',
    Analyst = 'Analyst',
    Customer= 'Customer'
}